export default {
  namespaced: true,
  state: {
    step: 1,
    model: null,
    versendenNEZOPostfach: null,
    isVertretung: false,
    wmiArt: null,
    wmi3Stellen: null,
    wmi6Stellen: null,
    unternehmensbezeichnung: null,
    zusatzUnternehmensbezeichnung: null,
    datenRichtigkeit: false,
    antragsbestaetigung: false,
  },
  getters: {
    isVertretung (state) {
      return state.isVertretung
    },
    unternehmensbezeichnung (state) {
      return state.unternehmensbezeichnung
    },
    versendenNEZOPostfach (state) {
      return state.versendenNEZOPostfach
    },
    zusatzUnternehmensbezeichnung (state) {
      return state.zusatzUnternehmensbezeichnung
    },
    step (state) {
      return state.step
    },
    model (state) {
      return state.model
    },
    wmiArt (state) {
      return state.wmiArt
    },
    wmi3Stellen (state) {
      return state.wmi3Stellen
    },
    wmi6Stellen (state) {
      return state.wmi6Stellen
    },
    datenRichtigkeit (state) {
      return state.datenRichtigkeit
    },
    antragsbestaetigung (state) {
      return state.antragsbestaetigung
    },
  },
  mutations: {
    reset (state) {
      state.loggedin = false
      state.vertretungsberechtigung = null
      state.versendenNEZOPostfach = null
      state.wmiArt = null
      state.wmi3Stellen = null
      state.wmi6Stellen = null
      state.datenRichtigkeit = false
      state.antragsbestaetigung = false
      state.unternehmensbezeichnung = null
      state.zusatzUnternehmensbezeichnung = null
    },

    unternehmensbezeichnung (state, unternehmensbezeichnung) {
      state.unternehmensbezeichnung = unternehmensbezeichnung
    },
    zusatzUnternehmensbezeichnung (state, zusatzUnternehmensbezeichnung) {
      state.zusatzUnternehmensbezeichnung = zusatzUnternehmensbezeichnung
    },
    isVertretung (state, isVertretung) {
      state.isVertretung = isVertretung
    },
    versendenNEZOPostfach (state, versendenNEZOPostfach) {
      state.versendenNEZOPostfach = versendenNEZOPostfach
    },
    step (state, step) {
      state.step = step
    },
    increaseStep (state) {
      state.step++
    },
    decreaseStep (state) {
      state.step--
    },
    model (state, model) {
      state.model = model
    },
    wmiArt (state, wmiArt) {
      state.wmiArt  = wmiArt
    },
    wmi3Stellen (state, wmi3Stellen) {
      state.wmi3Stellen  = wmi3Stellen
    },
    wmi6Stellen (state, wmi6Stellen) {
      state.wmi6Stellen = wmi6Stellen
    },
    datenRichtigkeit (state, datenRichtigkeit) {
      state.datenRichtigkeit = datenRichtigkeit
    },
    antragsbestaetigung (state, antragsbestaetigung) {
      state.antragsbestaetigung = antragsbestaetigung
    },
  },
  actions: {

  }
}
